import { Button } from "@/components/ui/button";
import type Widget from "@/model/widget";
import WidgetCard from "@/pages/components/widget/widget-card";

type IWidgetOptionsPT = {
  widget: Widget;
};

const WidgetOptionsPT: React.FC<IWidgetOptionsPT> = ({ widget }) => {
  const renderWidget = () => {
    const handlePhoneButtonClick = (phone: string | undefined) => {
      window.open(`tel:${phone}`);
    };

    const handleWebButtonClick = (url: string | undefined) => {
      window.open(url, "_blank");
    };

    return (
      <div className="mx-3">
        <p>{widget?.details[0]?.widgetContent}</p>
        <div className="my-3 flex flex-wrap gap-2 self-center">
          {(widget?.details[0]?.phone?.length ?? 0) > 0 ? (
            <Button
              onClick={() => handlePhoneButtonClick(widget?.details[0]?.phone)}
              className="bg-primary"
            >
              {widget?.details[0]?.displayPhoneNumberButtonName}
            </Button>
          ) : null}
          {(widget?.details[0]?.website?.length ?? 0) > 0 ? (
            <Button
              onClick={() => handleWebButtonClick(widget?.details[0]?.website)}
              className="bg-primary"
            >
              {widget?.details[0]?.displayWebsiteName}
            </Button>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <WidgetCard title={widget?.widgetDisplayName}>{renderWidget()}</WidgetCard>
  );
};

export default WidgetOptionsPT;
